import PurchaseListLotus from '../../../components/PurchaseListLotus';
import Location from '../../../components/Location.jsx'
import LogisiticsDetails from '../../../components/LogisiticsDetails';
import 'animate.css';
import LotusLogo from '../../../static/Lotus/LotusLogo.png';
import {lotusFall2023Drills, lotusFall2023option1Bundle,} from './LotusSpringTwoData'
import './lotus.scss'
import '../school_programming.scss'
import '../../../App.scss'

export default function Lotus221to320() {
  return (
    <section className="section d-flex flex-column align-items-center justify-content-center">
    <div className="info camps__container animate__animated animate__fadeInRight">
      <h4 className='title'>Wednesday Enrichment at Lotus School - Grades K-4 </h4>
      <h4 className='disclaimer'>This program is available for Lotus students only</h4>
      <h4 className='disclaimer2'>Flexible Payment Plans Available Upon Request</h4>
      {/* <h4 className='disclaimer'>Registration Extended Until 9/3 Midnight!</h4> */}
      <div className='program__container'>
        <div className="purchase">
          <PurchaseListLotus 
            type="bundle-option1"
            header="Wednesday After School"
            subhead="All Sports!"
            data={lotusFall2023option1Bundle}
          />
            <LogisiticsDetails 
            header="Skills & Drills Focus"
            data={lotusFall2023Drills}        
          />
        </div>

        <div className='logistics'>
        <img
              className="img-fluid mb-4 pl-0"
              src={LotusLogo}
              alt="Lotus Logo"
            />
          <Location 
            link="https://maps.app.goo.gl/Xj8rJGuBx6k5BkDk8"
            name="Lotus School"
            street="29067 W Grass Lake Rd"
            city="Fox Lake, IL 60020"
          />
        </div>

      </div>
      {/* close camp container div */}
    </div>
    {/* close info div */}
  </section>
)
}